import Base from './Base';

export default class Shop extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props) {
        if (!props) {
            props = {};
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.name = this.assign('name', props);
        this.address = this.assign('address', props);
        this.phone = this.assign('phone', props);
        this.email = this.assign('email', props);
        this.operatingHours = this.assign('operatingHours', props) || {
            monday: { open: '09:00', close: '21:00', closed: false },
            tuesday: { open: '09:00', close: '21:00', closed: false },
            wednesday: { open: '09:00', close: '21:00', closed: false },
            thursday: { open: '09:00', close: '21:00', closed: false },
            friday: { open: '09:00', close: '21:00', closed: false },
            saturday: { open: '10:00', close: '20:00', closed: false },
            sunday: { open: '10:00', close: '18:00', closed: false }
        };
        this.minStaffPerShift = this.assign('minStaffPerShift', props) || 2;
        this.color = this.assign('color', props) || '#3174ad';
        this.active = props.active !== undefined ? props.active : true;
        this.timezone = this.assign('timezone', props) || 'Europe/Bucharest';
        this.employees = this.assign('employees', props) || [];
        this.createdAt = props.createdAt;
        this.updatedAt = props.updatedAt;
    }

    export() {
        return {
            id: this.id,
            name: this.name,
            address: this.address,
            phone: this.phone,
            email: this.email,
            operatingHours: this.operatingHours,
            minStaffPerShift: this.minStaffPerShift,
            color: this.color,
            active: this.active,
            timezone: this.timezone
        };
    }
}
